/**
 * Génère un identifiant de navigateur stable (fingerprint léger).
 * Combinaison de signaux passifs : userAgent, langue, timezone,
 * résolution écran, nombre de cœurs CPU, mémoire appareil.
 * Stocké dans localStorage pour persister entre sessions.
 * Ne collecte aucune donnée personnelle identifiable.
 */

const STORAGE_KEY = "lexhab_fid";

function buildRawFingerprint() {
  const nav = window.navigator;
  const scr = window.screen;

  const parts = [
    nav.userAgent || "",
    nav.language || "",
    Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    `${scr.width}x${scr.height}`,
    String(scr.colorDepth || ""),
    String(nav.hardwareConcurrency || ""),
    String(nav.deviceMemory || ""),
    nav.platform || "",
  ];

  return parts.join("|");
}

async function sha256(str) {
  const buf = new TextEncoder().encode(str);
  const hashBuf = await crypto.subtle.digest("SHA-256", buf);
  const arr = Array.from(new Uint8Array(hashBuf));
  return arr.map((b) => b.toString(16).padStart(2, "0")).join("");
}

/**
 * Retourne un fingerprint hex de 16 caractères, stable pour ce navigateur.
 * Mis en cache dans localStorage.
 */
export async function getFingerprint() {
  // 1. Essayer le cache localStorage
  try {
    const cached = localStorage.getItem(STORAGE_KEY);
    if (cached && /^[a-f0-9]{16}$/.test(cached)) return cached;
  } catch (_) {}

  // 2. Générer
  let fid = "unknown";
  try {
    const raw = buildRawFingerprint();
    const hash = await sha256(raw);
    fid = hash.slice(0, 16); // 16 hex chars = 64 bits d'entropie, suffisant
  } catch (_) {
    // Si crypto.subtle indisponible (contexte non-HTTPS), fallback aléatoire persistant
    fid = Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10);
    fid = fid.slice(0, 16);
  }

  // 3. Persister
  try {
    localStorage.setItem(STORAGE_KEY, fid);
  } catch (_) {}

  return fid;
}
